import React, { useState } from 'react';
import TenantList from '../components/tenants/TenantList.tsx';
import TenantForm from '../components/tenants/TenantForm.tsx';
import { useTenants } from '../hooks/useTenants.ts';
import { Tenant } from '../types/tenant.ts';
import '../styles/Tenants.css';
import LoadingSpinner from '../components/shared/LoadingSpinner.tsx';
import ErrorMessage from '../components/shared/ErrorMessage.tsx';

const Tenants = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState<Tenant | null>(null);
  const { 
    tenants, 
    loading, 
    error, 
    tenantsWithDeboarding, 
    addTenant, 
    updateTenant, 
    deleteTenant, 
    deboardTenant,
    fetchTenants 
  } = useTenants();

  const handleAddNew = () => {
    setSelectedTenant(null);
    setIsFormOpen(true);
  };

  const handleEdit = (tenant: Tenant) => {
    setSelectedTenant(tenant);
    setIsFormOpen(true);
  };

  const handleClose = () => {
    setIsFormOpen(false);
    setSelectedTenant(null);
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} />;

  return (
    <div className="tenants-page">
      <div className="tenants-header tenant-group">
        <h1>Tenants</h1>
        <button className="btn-primary" onClick={handleAddNew}>
          Add New Tenant
        </button>
      </div>

      <TenantList
        tenants={tenants}
        onEdit={handleEdit}
        onDelete={deleteTenant}
        tenantsWithDeboarding={tenantsWithDeboarding}
        onDeboard={deboardTenant}
        onRefresh={fetchTenants}
      />

      {isFormOpen && (
        <TenantForm
          tenant={selectedTenant}
          onSubmit={async (data) => {
            if (selectedTenant) {
              await updateTenant(selectedTenant.id, data as Tenant);
            } else {
              await addTenant(data as Tenant);
            }
            handleClose();
          }}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

export default Tenants;
